
import WDPane from './wd-pane';
import WDForm from '../form/wd-form';
import WDUtil from '../../core/wd-util';

export default class WDPaneForm extends WDPane
{

  #options = {};
  #form = null;

  constructor(opts)
  {
    super(opts).classList.add('wd-pane-form');

    if (opts) WDUtil.merge(this.#options, opts);

    //build the form  
    this.#form = new WDForm(this.#options);
    this.body.append(this.#form);
  };

  get form() { return this.#form; };
  get model() { return this.#form.model; };
  get items() { return this.#form.items; };

  get dirty() { return this.#form.dirty; };
  set dirty(val) { this.#form.dirty = val; };

  get value() { return this.#form.value; };
  set value(val) { return this.#form.value = val; };

  get readonly() { return this.#form.readonly; };
  set readonly(val) { return this.#form.readonly = val; };

  addForms(data) { return this.#form.addForms(data); };
  addForm(data) { return this.#form.addForm(data); };
  getItem(itemName) { return this.#form.getItem(itemName); };
  validate(data) { return this.#form.validate(data); };

  //
  reset()
  {
    this.resetNavbar();
    this.resetToolbar();

    this.#form.remove();
    this.#form = new WDForm(this.#options);
    this.body.append(this.#form);

    this.setup();
  };

	req() { return this.form.req(); };
	post() { return this.form.post(); };
	del() { return this.form.del(); };

	cleanupCallback()
	{
		// Clean up form
		if (this.#form) {
			this.#form = null;
		}

		// Clear options
		this.#options = null;

		super.cleanupCallback();
	}

};

customElements.define('wd-pane-form', WDPaneForm);